<template>
	<div class="chat-container">
		<!-- 会话列表（客服端） -->
		<div class="session-box" v-if="isAdmin">
			<el-input placeholder="请输入手机号" v-model="phone" class="session-input" @input="fetchLeftList2"
				size="small"></el-input>
			<div class="session-header" v-if="unreadByAdmin>0">
				<el-badge :value="unreadByAdmin" :max="9999999" type="danger" class="danger-box"
					style="position:absolute;top:22px;right:-215px;" @click="fetchLeftList" v-if="Loading2">
				</el-badge>
				<h2>会话列表</h2>
				<div class="session-count">
					共 {{ leftList.length }} 个会话
				</div>
			</div>
			<div v-else>
				<div class="session-header">
					<h2>会话列表</h2>
					<div class="session-count">
						共 {{ leftList.length }} 个会话
					</div>
				</div>
			</div>
		</div>
		<div class="session-list" @scroll="handleScroll" ref="leftList" v-if="isAdmin">
			<div v-for="(item,index) in leftList" :key="item.userId" :class="['session-item', item.hasNewMessage ? 'has-new' : '', 
                 currentSessionUserId === item.userId ? 'active1' : '']" @click="switchSession(item,index)">
				<div class="session-info">
					<div v-if='item.hasUnread>0'>
						<el-badge :value="item.hasUnread" :max="9999999" type="danger" class="danger-box">
							<div><img style="width: 40px;height: 40px;border-radius: 8px;margin: 4px 10px;"
									:src="'http://'+item.headPortrait" alt=""></div>
							<div style="width: 100%;">
								<h3>{{ item.userPhone }}</h3>
								<p class="last-message">
									<span v-if="item.lastType=='IMAGE'">[图片]</span>
									<span v-else-if="item.lastType=='VIDEO'">[视频]</span>
									<span v-else>{{ item.lastMessageContent }}</span>
									<span class="time">{{formatTime(item.lastMessageTime)}}</span>
								</p>
							</div>
						</el-badge>
					</div>
					<div v-else class="danger-box">
						<div><img style="width: 40px;height: 40px;border-radius: 8px;margin: 4px 10px;"
								:src="'http://'+item.headPortrait" alt=""></div>
						<div style="width: 100%;">
							<h3>{{ item.userPhone }}</h3>
							<p class="last-message">
								<span v-if="item.lastType=='IMAGE'">[图片]</span>
								<span v-else-if="item.lastType=='VIDEO'">[视频]</span>
								<span v-else>{{ item.lastMessageContent }}</span>
								<span class="time">{{formatTime(item.lastMessageTime)}}</span>
							</p>
						</div>
					</div>
				</div>
				<div v-if="item.unreadCount > 0" class="unread-badge">
					{{ item.unreadCount }}
				</div>
			</div>
			<div v-if="leftList.length === 0" class="empty-sessions">
				<div class="empty-icon">
					<svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
							stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						<path
							d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
							stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</div>
				<p>暂无会话</p>
			</div>
		</div>

		<!-- 聊天区域 -->
		<div class="chat-area">
			<!-- 聊天对象信息栏 -->
			<div class="chat-header" v-if="currentSessionUserId">
				<div class="chat-user-info" v-if="customData.agent">
					<div class="user-details">
						<h3 class="user-name">{{customData.agent}}</h3>
						<p class="user-status">
							<span class="status-dot online"></span>
							<span class="status-text">{{customData.company}}</span>
							<span class="status-time">{{customData.role}}
								{{currentSessionUserPhone}}<span v-if="customData.online"
									style="margin-left: 6px;color: #1281ef;">在线</span><span v-else
									style="margin-left: 6px;">离线</span></span>
						</p>
					</div>
				</div>
			</div>

			<!-- 未选择会话时的提示 -->
			<div class="no-session-selected" v-else>
				<div class="selection-prompt">
					<div class="prompt-icon">
						<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</div>
					<h3>选择会话开始聊天</h3>
					<p>从左侧会话列表中选择一个用户开始对话</p>
				</div>
			</div>


			<!-- 消息列表 -->
			<div class="message-list" ref="messageList" v-if="currentSessionUserId">
				<!-- <div class="date-divider" v-if="showDateDivider">
					<span class="divider-line"></span>
					<span class="divider-text">今天</span>
					<span class="divider-line"></span>
				</div> -->

				<div v-for="(msg,index) in currentMessages" :key="index" class="message-item">
					<div v-if="isAdmin">
						<!-- 时间分隔线 -->
						<div class="time-divider" v-if="shouldShowTimeDivider(msg)">
							{{ formatMessageTime(msg.createdAt) }}
						</div>
						<div v-if="msg.userId === msg.senderId">
							<div class="message-wrapper admin-message">
								<div class="avatar-container">
									<img class="avatar" :src="'http://'+msg.headPortrait" alt="用户头像">
								</div>
								<div class="message-content-wrapper">
									<span class="sender-name">{{msg.sendPhone}}</span>
									<div class="message-content" v-if="msg.type=='TEXT'">
										<p>{{ msg.content }}</p>
									</div>
									<div v-if="msg.type=='VIDEO'">
										<video controls style="width: 215px;height: 120px;">
											<source :src="msg.content" type="video/mp4">
											您的浏览器不支持HTML5视频播放。
										</video>
									</div>
									<div v-if="msg.type=='IMAGE'">
										<el-image @click="bigImg(msg.content)" :src="msg.content"
											:preview-src-list="srcList" class="message-image">
										</el-image>
									</div>
								</div>
							</div>
							<div class="message-time-footer admin-time">{{ formatTime(msg.createdAt) }}</div>
						</div>
						<div v-else>
							<!-- 时间分隔线 -->
							<div class="time-divider" v-if="shouldShowTimeDivider(msg)">
								{{ formatMessageTime(msg.createdAt) }}
							</div>
							<div class="message-wrapper user-wrapper">
								<div class="avatar-container">
									<img class="avatar" :src="'http://'+msg.headPortrait" alt="客服头像">
								</div>
								<div class="message-content-wrapper">
									<span class="sender-name">{{msg.sendPhone}}</span>
									<div class="message-content" v-if="msg.type=='TEXT'">
										<p>{{ msg.content }}</p>
									</div>
									<div v-if="msg.type=='VIDEO'">
										<video controls style="width: 215px;height: 120px;">
											<source :src="msg.content" type="video/mp4">
											您的浏览器不支持HTML5视频播放。
										</video>

									</div>
									<div v-if="msg.type=='IMAGE'">
										<el-image :src="msg.content" :preview-src-list="[msg.content]"
											:preview-teleported="true" class="message-image" fit="cover">
										</el-image>
									</div>
								</div>
							</div>
							<div class="message-time-footer user-time">{{ formatTime(msg.createdAt) }}</div>
						</div>
					</div>

					<div v-else>
						<div v-if="msg.userId === msg.senderId">
							<div class="message-wrapper user-wrapper">
								<div class="avatar-container">
									<img class="avatar" :src="'http://'+msg.headPortrait" alt="客服头像">
								</div>
								<div class="message-content-wrapper">
									<span class="sender-name">{{msg.sendPhone}}</span>
									<div class="message-content" v-if="msg.type=='TEXT'">
										<p>{{ msg.content }}</p>
									</div>
									<div v-if="msg.type=='VIDEO'">
										<video controls style="width: 215px;height: 120px;">
											<source :src="msg.content" type="video/mp4">
											您的浏览器不支持HTML5视频播放。
										</video>
									</div>
									<div v-if="msg.type=='IMAGE'">
										<el-image @click="bigImg(msg.content)" :src="msg.content"
											:preview-src-list="srcList" class="message-image">
										</el-image>
									</div>
								</div>
							</div>
							<div class="message-time-footer user-time">{{ formatTime(msg.createdAt) }}</div>
						</div>
						<div v-else>
							<div class="message-wrapper admin-message">
								<div class="avatar-container">
									<img class="avatar" :src="'http://'+msg.headPortrait" alt="客服头像">
								</div>
								<div class="message-content-wrapper">
									<span class="sender-name">{{msg.sendPhone}}</span>
									<div class="message-content" v-if="msg.type=='TEXT'">
										<p>{{ msg.content }}</p>
									</div>
									<div v-if="msg.type=='VIDEO'">
										<video controls style="width: 215px;height: 120px;">
											<source :src="msg.content" type="video/mp4">
											您的浏览器不支持HTML5视频播放。
										</video>
									</div>
									<div v-if="msg.type=='IMAGE'">
										<el-image :src="msg.content" :preview-src-list="[msg.content]"
											:preview-teleported="true" class="message-image" fit="cover">
										</el-image>
									</div>
								</div>
							</div>
							<div class="message-time-footer admin-time">{{ formatTime(msg.createdAt) }}</div>
						</div>
					</div>
				</div>
				<div v-if="currentMessages.length === 0" class="empty-state">
					<div class="empty-icon">
						<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M8 10H16M8 14H12M6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20Z"
								stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</div>
					<p>暂无消息，开始对话吧</p>
				</div>
			</div>
			<div class="input-area" v-if="currentSessionUserId">
				<div class="input-container" :style="{ width: inputWidth + 'px', height: inputHeight + 'px' }"
					ref="resizableInput">
					<div class="message-input" contenteditable="true" placeholder="输入消息..." @input="handleInput"
						@paste="handlePaste" @drop="handleDrop" @dragover.prevent @keydown="handleKeyDown"
						ref="messageInput">
					</div>
					<div class="resize-handles">
						<div class="resize-handle-item resize-top" @mousedown="startResize($event, 'top')"></div>
						<div class="resize-handle-item resize-bottom" @mousedown="startResize($event, 'bottom')"></div>
					</div>
					<div class="input-controls">
						<div class="input-actions">
							<button class="action-btn" title="上传图片" @click="triggerImageUpload">
								图片
								<input type="file" ref="fileInput" accept="image/*" style="display: none"
									@change="handleImageUpload">
							</button>
							<button class="action-btn" title="上传视频" @click="triggerVideoUpload">
								视频
								<input type="file" ref="fileInput2" accept="video/*" style="display: none"
									@change="handleVideoUpload">
							</button>
							<el-dropdown class="fl_r" trigger="hover" @command="tapMusic">
								<button class="action-btn">
									提示音
									<i class="el-icon-caret-top"></i>
								</button>
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item divided command="qq">QQ提示音</el-dropdown-item>
										<el-dropdown-item divided command="xq">戏曲提示音</el-dropdown-item>
										<el-dropdown-item divided command="jc">机场提示音</el-dropdown-item>
										<el-dropdown-item divided command="dxts">电子提示音</el-dropdown-item>
										<el-dropdown-item divided command="dx">短信提示音</el-dropdown-item>
										<el-dropdown-item divided command="cgtx">成功提示音</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>

						</div>

						<div class="resize-controls">
							<div class="resize-handle" @mousedown="startResize($event, 'bottom-right')"></div>
						</div>
					</div>
				</div>

				<button @click="sendMessage" class="send-button">
					<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M22 2L11 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round" />
						<path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" stroke-width="2"
							stroke-linecap="round" stroke-linejoin="round" />
					</svg>
					<span>发送</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		log
	} from '../../api/jssip-3.6.3';
	import {
		webGetHeadPortrait,
	} from '../../api/sumIndex.js';
	export default {
		name: "ChatComponent",
		data() {
			return {
				userId: "",
				userName: "",
				ms_username: localStorage.getItem('ms_username'),
				isAdmin: false,
				token: "",
				ws: null,
				inputContent: "",
				currentSessionUserId: "",
				currentSessionUserPhone: "",
				customData: '',
				currentMessages: [],
				srcList: [],
				leftList: [],
				wsUrl: "",
				hasUnread: 0,
				reconnectAttempts: 0,
				maxReconnectAttempts: 5,
				reconnectTimeout: null,
				quillInstance: null,
				leftPage: 1,
				isLoading: false,
				userLastActive: {}, // 存储用户最后活跃时间
				showDateDivider: true,
				unreadByAdmin: 0,
				unreadByUser: null,
				pastedImages: [], // 存储粘贴的图片
				phone: '',
				calculateLatestUnread: false,
				onlineServers: localStorage.getItem('onlineServer'),
				inputWidth: 400,
				inputHeight: 150,
				isResizing: false,
				resizeDirection: '',
				startX: 0,
				startY: 0,
				startWidth: 0,
				startHeight: 0,
				Loading2: true,
				headerUrl: '',
				audio: new Audio('https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/kf-notice/qq.mp3'),
			};
		},
		computed: {
			canSendMessage() {
				return (
					this.inputContent.trim() &&
					this.ws &&
					this.ws.readyState === WebSocket.OPEN &&
					this.currentSessionUserId
				);
			}
		},
		watch: {
			currentMessages: {
				handler() {
					this.scrollToBottom();
				},
				deep: true
			}
		},
		mounted() {
			this.userId = localStorage.getItem('user') || "";
			this.isAdmin = localStorage.getItem('ms_role') == 'admin';
			this.token = localStorage.getItem("token") || "";
			this.onlineServers = localStorage.getItem("onlineServer");
			console.log(this.onlineServers, 'this.wsUrl.wsUrl')
			this.initWebSocket();
		},
		beforeUnmount() {
			this.cleanupWebSocket();
		},
		methods: {
			tapMusic(item) {
				const audioMap = {
					'xq': 'xq.mp3',
					'qq': 'qq.mp3',
					'jc': 'jc.mp3',
					'dxts': 'dxts.mp3',
					'dx': 'dx.mp3',
					'cgtx': 'cgtx.mp3'
				};
				if (audioMap[item]) {
					const audioUrl =
						`https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/kf-notice/${audioMap[item]}`;
					this.audio = new Audio(audioUrl);
				}
			},

			// 格式化消息时间（用于时间分隔线）
			formatMessageTime(timeStr) {
				if (!timeStr) return "";
				const date = new Date(timeStr);
				return date.toLocaleTimeString([], {
					hour: '2-digit',
					minute: '2-digit'
				});
			},
			// 判断是否显示时间分隔线
			shouldShowTimeDivider(index) {
				if (index === 0) return true;
				try {
					const currentMsg = this.currentMessages?.[index];
					const prevMsg = this.currentMessages?.[index - 1];
					if (!currentMsg?.createdAt || !prevMsg?.createdAt) {
						return false;
					}
					const currentTime = new Date(currentMsg.createdAt).getTime();
					const prevTime = new Date(prevMsg.createdAt).getTime();
					return (currentTime - prevTime) > 5 * 60 * 1000;
				} catch (e) {
					console.error('时间解析失败:', e);
					return false;
				}
			},

			// 格式化时间显示
			formatTime(timestampStr) {
			    const now = new Date();
			    const date = new Date(timestampStr);
			    
			    // 获取当前日期和目标日期的年月日
			    const nowYear = now.getFullYear();
			    const nowMonth = now.getMonth();
			    const nowDay = now.getDate();
			    
			    const targetYear = date.getFullYear();
			    const targetMonth = date.getMonth();
			    const targetDay = date.getDate();
			    
			    const hours = date.getHours().toString().padStart(2, '0');
			    const minutes = date.getMinutes().toString().padStart(2, '0');
			    const timeStr = `${hours}:${minutes}`;
			    
			    // 判断是否是今天
			    if (nowYear === targetYear && nowMonth === targetMonth && nowDay === targetDay) {
			        return `${timeStr}`;
			    }

			    // 不同年份时显示完整年月日
			    if (nowYear !== targetYear) {
			        const year = targetYear.toString();
			        const month = (targetMonth + 1).toString().padStart(2, '0');
			        const day = targetDay.toString().padStart(2, '0');
			        return `${year}-${month}-${day} ${timeStr}`;
			    }
			    
			    // 同一年但不是最近几天，显示年月日时分
				const year = targetYear.toString();
			    const month = (targetMonth + 1).toString().padStart(2, '0');
			    const day = targetDay.toString().padStart(2, '0');
			    return `${year}-${month}-${day} ${timeStr}`;
			},
			//监听左侧导航到底部  增加page
			handleScroll(event) {
				if (this.isLoading) return; // 如果正在加载，直接返回
				const element = event.target;
				// 距离底部还有100px时就触发加载
				const threshold = 300;
				const isNearBottom = element.scrollHeight - element.scrollTop - element.clientHeight <= threshold;
				if (isNearBottom) {
					this.isLoading = true; // 设置加载状态
					this.fetchLeftList();
				}
			},
			// 滚动到最新消息
			scrollToBottom() {
				this.$nextTick(() => {
					this.$nextTick(() => {
						if (this.$refs.messageList) {
							this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight;
						}
					});
				});
			},
			// 切换会话（客服端）
			switchSession(item, index) {
				this.unreadByAdmin = this.unreadByAdmin - item.hasUnread;
				this.currentSessionUserId = item.userId;
				this.currentSessionUserPhone = item.userPhone;
				this.userName = item.userPhone;
				this.leftList[index].hasUnread = 0;
				this.fetchMessageHistory(item.userId);
				setTimeout(i => {
					this.$nextTick(() => {
						this.$nextTick(() => {
							if (this.$refs.messageList) {
								this.$refs.messageList.scrollTop = this.$refs.messageList
									.scrollHeight;
							}
						});
					});
				}, 200)
			},
			// 判断是否是当前会话的消息
			isCurrentSessionMessage(message) {
				if (!this.isAdmin) {
					// 用户端只处理自己的消息
					return message.userId === this.userId;
				} else {
					// 客服端只处理当前选中会话的消息
					return message.userId === this.currentSessionUserId;
					// message.senderId === this.currentSessionUserId
				}
			},
			// 处理新消息
			handleNewMessage(message) {
				// 如果是当前会话的消息，直接添加到列表
				let a = false;
				if (this.audio) {
					this.audio.play();
				} else {
					this.audio = new Audio(
						'https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/kf-notice/qq.mp3')
					this.audio.play();
				}
				this.leftList.forEach((i, index) => {
					if (message.userId == i.userId) {
						a = true;
						i.lastMessageContent = message.content;
						i.lastType = message.type;
						i.lastMessageTime = message.createdAt;
						if (message.userId !== this.currentSessionUserId) {
							i.hasUnread++;
							this.unreadByAdmin += 1;
						}
					}
				});
				if (a == false) {
					//加到最顶部
					let b = {
						lastMessageContent: message.content,
						lastType: message.type,
						lastMessageTime: message.createdAt,
						hasUnread: 1,
						userPhone: message.sendPhone,
						headPortrait: message.portrait,
						userId: message.userId,
					}
					this.leftList.unshift(b);
				}
				this.leftList.sort((a, b) => {
					return new Date(b.lastMessageTime) - new Date(a.lastMessageTime);
				});
				if (this.isCurrentSessionMessage(message)) {
					message.headPortrait = message.portrait;
					this.currentMessages.push(message); //给右边对话添加
				}
			},

			// 标记消息为已读
			async markMessagesAsRead(userId) {
				try {
					const response = await fetch(
						`/webket/customer-service/markerMessages?userId=${userId}&currentUserId=${localStorage.getItem('user')}`
					);
					if (response.ok) {
						//反馈后台已读
						// const messages = await response.json();
					} else {
						console.error("标记消息为已读:", response.status);
					}
				} catch (error) {
					console.error("标记已读失败:", error);
				}
			},
			// 获取消息历史记录
			async fetchMessageHistory(targetUserId) {
				try {
					const response = await fetch(
						`/webket/customer-service/messages?userId=${targetUserId}&role=${localStorage.getItem('ms_role')}&currentUserId=${localStorage.getItem('user')}`
					);
					if (response.ok) {
						const messages = await response.json();
						console.log(messages, '获取消息历史记录获取消息历史记录获取消息历史记录')
						this.currentMessages = messages.data;
						this.customData = messages.customData;
						setTimeout(i => {
							this.$nextTick(() => {
								this.$nextTick(() => {
									if (this.$refs.messageList) {
										this.$refs.messageList.scrollTop = this.$refs
											.messageList
											.scrollHeight;
									}
								});
							});
						}, 200)
						// // 标记为已读
						// if (messages.data[0].senderId == this.currentSessionUserId) {
						// 	this.markMessagesAsRead(messages.data[0].senderId);
						// }
					} else {
						console.error("获取消息历史失败:", response.status);
					}
				} catch (error) {
					console.error("获取消息历史失败:", error);
				}
			},
			// 获取会话列表（客服端）
			async fetchLeftList(e) {
				if (e) {
					this.calculateLatestUnread = true;
				}
				try {
					const response = await fetch(
						`/webket/customer-service/admin/sessions?currentUserId=${localStorage.getItem('user')}&totalSize=${this.leftList.length}&phone=${this.phone}&calculateLatestUnread=${this.calculateLatestUnread}`
					);
					if (response.ok) {
						this.isLoading = false;
						this.calculateLatestUnread = false;
						let result = await response.json();
						this.unreadByAdmin = result.customData.unreadByAdmin;
						this.unreadByUser = result.customData.unreadByUser;
						if (result.data.length > 0) {
							this.leftList.push(...result.data);
						}
						if (this.unreadByUser) {
							this.Loading2 = false;
							this.$nextTick(() => {
								if (this.$refs.leftList) {
									this.$refs.leftList.scrollTo({
										top: this.unreadByUser * 69,
										behavior: 'smooth'
									});
									setTimeout(() => {
										this.Loading2 = true;
									}, 1000)
								}
							});
						}
					} else {
						console.error("获取会话列表失败:", response);
					}
				} catch (error) {
					console.error("获取会话列表失败:", error);
				}
			},
			// 获取会话列表（客服端）
			async fetchLeftList2(e) {
				try {
					const response = await fetch(
						`/webket/customer-service/admin/sessions?currentUserId=${localStorage.getItem('user')}&phone=${this.phone}&calculateLatestUnread=${this.calculateLatestUnread}`
					);
					if (response.ok) {
						this.isLoading = false;
						let result = await response.json();
						this.unreadByAdmin = result.customData.unreadByAdmin;
						this.unreadByUser = result.customData.unreadByUser;
						this.leftList = result.data;
					} else {
						console.error("获取会话列表失败:", response);
					}
				} catch (error) {
					console.error("获取会话列表失败:", error);
				}
			},
			// 发送消息
			async sendMessage() {
				const inputDiv = this.$refs.messageInput;
				const images = inputDiv.querySelectorAll('img');
				const videoContainers = inputDiv.querySelectorAll('div[style*="position: relative"]');
				const textContent = inputDiv.textContent.trim();
				// 处理图片消息
				if (images.length > 0) {
					for (const img of images) {
						// 如果是本地预览图（data URL），需要上传
						if (img.src.startsWith('data:')) {
							try {
								const blob = await this.dataURLToBlob(img.src);
								const file = new File([blob], `chat-image-${Date.now()}.png`, {
									type: 'image/png'
								});
								const imageUrl = await this.uploadImage(file);
								// 上传成功后，替换为服务器URL
								this.pastedImages.push(imageUrl)
								img.src = imageUrl;
							} catch (error) {
								console.error('图片上传失败:', error);
								this.$message.error('图片上传失败，请重试');
								continue;
							}
						}
						// 发送图片消息
						await this.sendImageMessage(img.src);
					}
				}
				// 处理视频消息
				if (videoContainers.length > 0) {
					for (const container of videoContainers) {
						const video = container.querySelector('video');
						const file = container._videoFile;
						if (file && video.src.startsWith('blob:')) {
							try {
								// 显示上传进度
								this.$message.info('视频上传中...');
								// 上传视频
								const videoUrl = await this.uploadVideo(file);
								this.$message.success('视频发送成功');
								// 清理blob URL
								URL.revokeObjectURL(video.src);
								await this.sendVideoMessage(videoUrl);
							} catch (error) {
								this.$message.error('视频上传失败，请重试');
								continue;
							}
						}
					}
				}

				// 处理文本消息
				if (textContent) {
					const message = {
						type: "TEXT",
						userId: this.currentSessionUserId,
						senderId: localStorage.getItem('user'),
						senderRole: localStorage.getItem('ms_role'),
						content: textContent,
						createdAt: new Date().toISOString(),
						sendPhone: localStorage.getItem('ms_username'),
						portrait: this.headerUrl,
					};
					if (this.isAdmin) {
						this.leftList.forEach((i, index) => {
							if (this.currentSessionUserId == i.userId) {
								i.lastMessageContent = textContent;
								i.lastType = 'TEXT';
								i.lastMessageTime = new Date().toISOString();
							}
						});
					}
					message.headPortrait = message.portrait;
					this.currentMessages.push(message); //给右边对话添加
					this.scrollToBottom();
					this.ws.send(JSON.stringify(message));
				}
				// 清空输入框
				inputDiv.innerHTML = '';
				this.inputContent = '';
			},

			// Data URL 转 Blob
			dataURLToBlob(dataURL) {
				return new Promise((resolve, reject) => {
					const arr = dataURL.split(',');
					const mime = arr[0].match(/:(.*?);/)[1];
					const bstr = atob(arr[1]);
					let n = bstr.length;
					const u8arr = new Uint8Array(n);
					while (n--) {
						u8arr[n] = bstr.charCodeAt(n);
					}
					resolve(new Blob([u8arr], {
						type: mime
					}));
				});
			},

			// 清理WebSocket连接
			cleanupWebSocket() {
				if (this.ws) {
					this.ws.close(1000, "正常关闭");
					this.ws = null;
				}
				if (this.reconnectTimeout) {
					clearTimeout(this.reconnectTimeout);
					this.reconnectTimeout = null;
				}
			},
			//获取自己的头像
			getwebGetHeadPortrait() {
				let data = {
					currentUserId: localStorage.getItem('user')
				};
				webGetHeadPortrait(data).then(res => {
					this.headerUrl = res.data.headPortrait.replace('http://', '');
				});
			},
			// 初始化WebSocket连接
			initWebSocket() {
				// 关闭现有连接
				this.cleanupWebSocket();

				this.wsUrl = this.isAdmin ?
					`${this.onlineServers}?token=${encodeURIComponent(this.token)}` :
					`${this.onlineServers}?token=${encodeURIComponent(this.token)}`;
				this.ws = new WebSocket(this.wsUrl);
				// 连接成功
				this.ws.onopen = () => {
					console.log("WebSocket连接成功");
					this.getwebGetHeadPortrait();
					this.reconnectAttempts = 0;
					// 非客服端直接加载自己的消息
					if (!this.isAdmin) {
						this.currentSessionUserId = this.userId;
						this.fetchMessageHistory(this.userId);
					} else {
						// 客服端加载会话列表
						this.fetchLeftList();
					}
				};

				// 接收消息
				this.ws.onmessage = (event) => {
					try {
						const message = JSON.parse(event.data);
						console.log(message,'message')
						// // 标记为已读
						if (message.senderId == this.currentSessionUserId) {
							this.markMessagesAsRead(message.senderId);
						}
						// 普通消息处理
						this.handleNewMessage(message);
					} catch (error) {
						console.error("解析消息失败:", error, event.data);
					}
				};
				// 连接关闭
				this.ws.onclose = (event) => {
					console.log("WebSocket连接关闭", event.code, event.reason);
					// 如果不是正常关闭，尝试重连
					if (event.code !== 1000 && this.reconnectAttempts < this.maxReconnectAttempts) {
						console.log(`尝试重连... (${this.reconnectAttempts + 1}/${this.maxReconnectAttempts})`);
						this.reconnectAttempts++;
						// 使用指数退避策略
						const delay = Math.min(3000 * Math.pow(2, this.reconnectAttempts - 1), 30000);
						this.reconnectTimeout = setTimeout(this.initWebSocket, delay);
					}
				};
				// 错误处理
				this.ws.onerror = (error) => {
					console.error("WebSocket错误:", error);
				};
			},

			// 上传图片到服务器
			async uploadImage(file) {
				const formData = new FormData();
				formData.append('file', file);
				formData.append('userId', localStorage.getItem('user'));
				const response = await fetch(`/api/yqt/media`, {
					method: 'POST',
					body: formData,
					headers: {
						// 注意：上传文件时不要设置Content-Type，浏览器会自动处理
						'Authorization': localStorage.getItem('token')
					}
				});
				if (!response.ok) {
					throw new Error(`上传失败，状态码: ${response.status}`);
				}
				const result = await response.json();
				if (result.code === 200 && result.data) {
					return result.data;
				} else {
					throw new Error('上传失败: ' + (result.message || '未知错误'));
				}
			},
			// 发送图片消息
			sendImageMessage(imageUrl) {
				if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
					alert('连接未建立，无法发送消息');
					return;
				}
				const message = {
					userId: this.currentSessionUserId,
					senderId: localStorage.getItem('user'),
					senderRole: localStorage.getItem('ms_role'),
					type: 'IMAGE', // 标记为图片类型
					content: imageUrl, // 内容为图片URL
					sendPhone: localStorage.getItem('ms_username'),
					createdAt: new Date().toISOString(),
					portrait: this.headerUrl,
				};
				message.headPortrait = message.portrait;
				this.currentMessages.push(message); //给右边对话添加
				if (this.isAdmin) {
					this.leftList.forEach((i, index) => {
						if (this.currentSessionUserId == i.userId) {
							i.lastMessageContent = imageUrl;
							i.lastType = 'IMAGE';
							i.lastMessageTime = new Date().toISOString();
						}
					});
					this.leftList.sort((a, b) => {
						return new Date(b.lastMessageMessageTime) - new Date(a.lastMessageTime);
					});
				}
				this.ws.send(JSON.stringify(message));
				// this.scrollToBottom();
			},
			bigImg(url) {
				this.srcList = [url];
			},
			// 处理输入框内容变化
			handleInput(event) {
				this.inputContent = event.target.textContent || '';
			},
			// 处理粘贴事件 - 优化图片粘贴
			handlePaste(event) {
				const clipboardData = event.clipboardData || window.clipboardData;
				const items = clipboardData.items;

				// 检查是否有图片数据
				let hasImage = false;
				for (let i = 0; i < items.length; i++) {
					const item = items[i];
					if (item.type.indexOf('image') !== -1) {
						hasImage = true;
						const file = item.getAsFile();
						this.handlePastedImage(file);
						event.preventDefault();
						break;
					}
				}
				// 如果没有图片，处理文本粘贴
				if (!hasImage) {
					const text = clipboardData.getData('text');
					document.execCommand('insertText', false, text);
					event.preventDefault();
				}
			},
			// 处理拖放事件
			handleDrop(event) {
				event.preventDefault();
				const files = event.dataTransfer.files;
				if (files.length > 0) {
					for (let i = 0; i < files.length; i++) {
						if (files[i].type.startsWith('image/')) {
							this.handlePastedImage(files[i]);
						}
					}
				}
			},
			// 处理粘贴的图片
			handlePastedImage(file) {
				if (!file || !file.type.startsWith('image/')) {
					return;
				}
				// 检查文件大小（限制为50MB）
				const maxSize = 20 * 1024 * 1024;
				if (file.size > maxSize) {
					this.$message.error('图片文件大小不能超过20MB');
					return;
				}
				const reader = new FileReader();
				reader.onload = (e) => {
					const img = document.createElement('img');
					img.src = e.target.result;
					img.style.maxWidth = '200px';
					img.style.maxHeight = '150px';
					img.style.borderRadius = '4px';
					img.style.margin = '2px';
					img.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
					// 插入图片到输入框
					const inputDiv = this.$refs.messageInput;
					inputDiv.appendChild(img);
					// 添加换行以便继续输入文本
					const br = document.createElement('br');
					inputDiv.appendChild(br);
					// 更新输入内容
					this.handleInput({
						target: inputDiv
					});
					// 聚焦到输入框
					inputDiv.focus();
				};
				reader.readAsDataURL(file);
			},
			startResize(e, direction) {
				this.isResizing = true;
				this.resizeDirection = direction;
				this.startX = e.clientX;
				this.startY = e.clientY;
				this.startWidth = this.inputWidth;
				this.startHeight = this.inputHeight;
				document.addEventListener('mousemove', this.resize);
				document.addEventListener('mouseup', this.stopResize);
				e.preventDefault();
			},

			resize(e) {
				if (!this.isResizing) return;
				const dx = e.clientX - this.startX;
				const dy = e.clientY - this.startY;
				switch (this.resizeDirection) {
					case 'bottom':
						this.inputHeight = this.startHeight + dy;
						break;
					case 'top':
						this.inputHeight = this.startHeight - dy;
						break;
				}
				// 限制最小尺寸
				this.inputWidth = Math.max(200, this.inputWidth);
				this.inputHeight = Math.max(150, this.inputHeight);
			},
			stopResize() {
				this.isResizing = false;
				document.removeEventListener('mousemove', this.resize);
				document.removeEventListener('mouseup', this.stopResize);
			},
			// 获取最后活跃时间
			getLastActiveTime(userId) {
				// 这里可以从用户数据中获取最后活跃时间
				// 简化实现，返回当前时间
				return new Date().toLocaleTimeString();
			},
			//键盘enter事件
			handleKeyDown(e) {
				if (e.key === 'Enter' && !e.shiftKey) {
					e.preventDefault();
					this.sendMessage();
				}
			},
			// 触发图片上传
			triggerImageUpload() {
				this.$refs.fileInput.click();
			},

			// 触发视频上传
			triggerVideoUpload() {
				this.$refs.fileInput2.click();
			},
			//上传视频
			handleVideoUpload(event) {
				const file = event.target.files[0];
				if (file) {
					this.handlePastedVideo(file);
				}
				// 清空input，以便再次选择同一文件
				event.target.value = '';
			},
			// 处理粘贴的视频 - 添加到输入框
			handlePastedVideo(file) {
				if (!file || !file.type.startsWith('video/')) {
					this.$message.error('请选择有效的视频文件');
					return;
				}
				// 检查文件大小（限制为50MB）
				const maxSize = 30 * 1024 * 1024;
				if (file.size > maxSize) {
					this.$message.error('视频文件大小不能超过30MB');
					return;
				}
				// 创建预览元素
				const videoContainer = document.createElement('div');
				videoContainer.style.position = 'relative';
				videoContainer.style.display = 'inline-block';
				videoContainer.style.margin = '2px';
				videoContainer.style.verticalAlign = 'middle';
				// 创建视频元素
				const video = document.createElement('video');
				video.src = URL.createObjectURL(file);
				video.controls = false;
				video.style.width = '120px';
				video.style.height = '80px';
				video.style.borderRadius = '4px';
				video.style.objectFit = 'cover';
				video.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
				// 鼠标悬停时显示控制条
				video.addEventListener('mouseenter', () => {
					video.controls = true;
				});
				video.addEventListener('mouseleave', () => {
					video.controls = false;
				});
				// 创建视频信息标签
				const videoInfo = document.createElement('div');
				videoInfo.style.position = 'absolute';
				videoInfo.style.bottom = '4px';
				videoInfo.style.right = '4px';
				videoInfo.style.background = 'rgba(0, 0, 0, 0.6)';
				videoInfo.style.color = 'white';
				videoInfo.style.padding = '2px 6px';
				videoInfo.style.borderRadius = '4px';
				videoInfo.style.fontSize = '10px';
				videoInfo.style.fontWeight = 'bold';
				// 获取视频时长
				const setVideoDuration = () => {
					const duration = video.duration;
					if (duration && !isNaN(duration)) {
						const minutes = Math.floor(duration / 60);
						const seconds = Math.floor(duration % 60);
					}
				};
				video.addEventListener('loadedmetadata', setVideoDuration);
				// 如果元数据已经加载
				if (video.readyState >= 1) {
					setVideoDuration();
				}
				// 组装元素
				videoContainer.appendChild(video);
				videoContainer.appendChild(videoInfo);
				// 存储文件引用
				videoContainer._videoFile = file;
				// 插入到输入框
				const inputDiv = this.$refs.messageInput;
				inputDiv.appendChild(videoContainer);
				// 添加换行以便继续输入文本
				const br = document.createElement('br');
				inputDiv.appendChild(br);
				// 更新输入内容
				this.handleInput({
					target: inputDiv
				});
				// 聚焦到输入框
				inputDiv.focus();
			},
			// 处理图片上传
			handleImageUpload(event) {
				const file = event.target.files[0];
				if (file) {
					this.handlePastedImage(file);
				}
				// 清空input，以便再次选择同一文件
				event.target.value = '';
			},

			// 发送视频消息
			sendVideoMessage(videoUrl) {
				if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
					alert('连接未建立，无法发送消息');
					return;
				}
				const message = {
					userId: this.currentSessionUserId,
					senderId: localStorage.getItem('user'),
					senderRole: localStorage.getItem('ms_role'),
					type: 'VIDEO', // 标记为视频类型
					content: videoUrl, // 内容为视频URL
					sendPhone: localStorage.getItem('ms_username'),
					createdAt: new Date().toISOString(),
					portrait: this.headerUrl,
				};
				message.headPortrait = message.portrait;
				this.currentMessages.push(message); //给右边对话添加
				this.ws.send(JSON.stringify(message));
				this.scrollToBottom();
				if (this.isAdmin) {
					this.leftList.forEach((i, index) => {
						if (this.currentSessionUserId == i.userId) {
							i.lastMessageContent = videoUrl;
							i.lastType = 'VIDEO';
							i.lastMessageTime = new Date().toISOString();
						}
					});
					this.leftList.sort((a, b) => {
						return new Date(b.lastMessageMessageTime) - new Date(a.lastMessageTime);
					});
				}
			},

			// 上传视频到服务器
			async uploadVideo(file) {
				return new Promise((resolve, reject) => {
					const formData = new FormData();
					formData.append('file', file);
					formData.append('userId', localStorage.getItem('user'));
					const xhr = new XMLHttpRequest();
					// 监听上传进度
					xhr.upload.addEventListener('progress', (e) => {
						if (e.lengthComputable) {
							const percentComplete = (e.loaded / e.total) * 100;
							this.uploadProgress = Math.round(percentComplete);
						}
					});
					xhr.addEventListener('load', () => {
						if (xhr.status === 200) {
							const result = JSON.parse(xhr.responseText);
							if (result.code === 200 && result.data) {
								resolve(result.data);
							} else {
								reject(new Error('上传失败: ' + (result.message || '未知错误')));
							}
						} else {
							reject(new Error(`上传失败，状态码: ${xhr.status}`));
						}
					});
					xhr.addEventListener('error', () => {
						reject(new Error('上传过程中发生网络错误'));
					});
					xhr.open('POST', `/api/yqt/media`);
					xhr.setRequestHeader('Authorization', localStorage.getItem('token'));
					xhr.send(formData);
				});
			},
		}
	};
</script>

<style scoped>
	.chat-container {
		display: flex;
		height: 84vh;
		overflow: hidden;
		border-radius: 12px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
		background-color: #fff;
		border: 1px solid #b7b7b7;
	}

	/* 会话列表样式 */
	.session-list {
		width: 320px;
		border-right: 1px solid #d5d5d5;
		overflow-y: auto;
		background-color: #f7f7f7;
		max-height: 800px;
		margin-top: 127px;
	}

	.session-list {
		overflow-y: hidden;
	}

	.session-list:hover {
		overflow-y: auto;
	}

	.session-header {
		padding: 10px 20px;
		background-color: white;
		position: relative;
	}

	.session-box {
		border-bottom: 1px solid #d5d5d5;
		border-right: 1px solid #d5d5d5;
		background-color: white;
		position: fixed;
		z-index: 1000;
		border-radius: 12px 0 0 0;
	}

	.session-input {
		width: 280px;
		border-radius: 0 !important;
		margin: 12px 20px 0;
	}

	.session-header h2 {
		margin: 0 0 8px 0;
		font-size: 18px;
		font-weight: 600;
		color: #1f2d3d;
	}

	.session-count {
		font-size: 13px;
		color: #5e6d82;
	}

	.session-item {
		padding: 10px 20px 8px;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
		display: flex;
		align-items: center;
		transition: all 0.2s ease;
		position: relative;
	}


	.session-item:hover {
		background-color: #dedede;
	}

	.session-item.has-new {
		background-color: #fff8f8;
	}

	.session-item.active1 {
		background-color: #dedede;
		border-left: 3px solid #1890ff;
	}

	.session-info {
		flex: 1;
		max-width: 270px;
		min-width: 260px;
		overflow: hidden;
	}

	/deep/.el-badge__content.is-fixed {
		position: absolute;
		top: 10px;
		right: 37px;
	}

	.session-info h3 {
		margin: 0 0 6px 0;
		font-size: 15px;
		font-weight: 600;
		color: #1f2d3d;
	}

	.last-message {
		color: #5e6d82;
		font-size: 13px;
		margin: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.last-message span:first-child {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1;
		margin-right: 8px;
	}

	.last-message .time {
		flex-shrink: 0;
		color: #97a8be;
		font-size: 12px;
	}

	.unread-badge {
		background: linear-gradient(135deg, #ff4d4f, #ff7875);
		color: white;
		border-radius: 10px;
		min-width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 600;
		margin-left: 10px;
		box-shadow: 0 2px 4px rgba(255, 77, 79, 0.2);
	}

	.empty-sessions {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 60px 20px;
		color: #97a8be;
		text-align: center;
		margin-top: 100px;
	}

	.empty-sessions .empty-icon {
		margin-bottom: 16px;
		color: #c0ccda;
	}

	/* 聊天区域样式 */
	.chat-area {
		flex: 1;
		display: flex;
		flex-direction: column;
		background-color: #f8f9fa;
		width: 80%;
	}

	/* 聊天头部信息栏 */
	.chat-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 24px;
		background-color: white;
		border-bottom: 1px solid #d5d5d5;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	}

	.chat-user-info {
		display: flex;
		align-items: center;
	}

	.user-avatar {
		margin-right: 12px;
	}

	.user-avatar img {
		width: 44px;
		height: 44px;
		border-radius: 12px;
		object-fit: cover;
	}

	.user-details h3 {
		margin: 0 0 4px 0;
		font-size: 16px;
		font-weight: 600;
		color: #1f2d3d;
	}

	.user-status {
		display: flex;
		align-items: center;
		margin: 0;
		font-size: 13px;
		color: #5e6d82;
	}

	.status-dot {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 6px;
	}

	.status-dot.online {
		background-color: #1281ef;
	}

	.status-text {
		margin-right: 12px;
	}

	.status-time {
		color: #97a8be;
	}

	.chat-actions {
		display: flex;
		gap: 8px;
	}

	.chat-actions .action-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		/* width: 52px; */
		height: 36px;
		border: none;
		background: transparent;
		border-radius: 8px;
		color: #5e6d82;
		cursor: pointer;
		transition: all 0.2s;
	}

	.chat-actions .action-btn:hover {
		background-color: #f5f7fa;
		color: #1890ff;
	}

	/* 未选择会话提示 */
	.no-session-selected {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		background-color: #f8f9fa;
	}

	.selection-prompt {
		text-align: center;
		color: #97a8be;
	}

	.prompt-icon {
		margin-bottom: 16px;
		color: #c0ccda;
	}

	.selection-prompt h3 {
		margin: 0 0 8px 0;
		font-size: 18px;
		font-weight: 500;
		color: #5e6d82;
	}

	.selection-prompt p {
		margin: 0;
		font-size: 14px;
	}

	/* 消息列表样式 */
	.message-list {
		flex: 1;
		padding: 24px;
		display: flex;
		flex-direction: column;
		background-color: #f8f9fa;
		overflow-y: auto;
	}




	/* 时间分隔线 */
	.date-divider,
	.time-divider {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 16px 0;
	}

	.date-divider {
		margin: 24px 0;
	}

	.divider-line {
		flex: 1;
		height: 1px;
		background-color: #e8e8e8;
	}

	.divider-text {
		padding: 0 12px;
		font-size: 12px;
		color: #97a8be;
		font-weight: 500;
	}

	.time-divider {
		font-size: 12px;
		color: #97a8be;
		padding: 4px 12px;
		background-color: rgba(255, 255, 255, 0.7);
		border-radius: 12px;
		margin: 8px auto;
	}

	.message-item {
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
	}

	.message-wrapper {
		display: flex;
	}

	.user-wrapper {
		flex-direction: row-reverse;
		align-self: flex-end;
	}

	.admin-message {
		align-self: flex-start;
	}

	.avatar-container {
		display: flex;
		align-items: flex-start;
	}

	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 12px;
		flex-shrink: 0;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.user-wrapper .avatar {
		margin-left: 12px;
		margin-right: 0;
	}

	.admin-message .avatar {
		margin-right: 12px;
		margin-left: 0;
	}

	.message-content-wrapper {
		display: flex;
		flex-direction: column;
		max-width: calc(100% - 52px);
	}

	.sender-name {
		font-size: 13px;
		color: #8492a6;
		margin-bottom: 6px;
		font-weight: 500;
	}

	.user-wrapper .sender-name {
		text-align: right;
		margin-right: 6px;
	}

	.admin-message .sender-name {
		margin-left: 6px;
	}

	.message-content {
		padding: 12px 16px;
		border-radius: 18px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		max-width: 400px;
		word-wrap: break-word;
		overflow-wrap: break-word;
		white-space: normal;
		position: relative;
	}

	.user-wrapper .message-content {
		background: linear-gradient(135deg, #1890ff, #096dd9);
		color: white;
		border-bottom-right-radius: 4px;
	}

	.admin-message .message-content {
		background-color: white;
		border: 1px solid #e8e8e8;
		border-bottom-left-radius: 4px;
		color: #1f2d3d;
	}

	.message-content p {
		margin: 0;
		line-height: 1.5;
	}

	.message-content video {
		width: 250px;
		height: 140px;
		border-radius: 8px;
	}

	.message-image {
		max-width: 200px;
		max-height: 150px;
		border-radius: 8px;
		transition: transform 0.2s;
	}

	/* .message-image:hover {
		transform: scale(1.02);
	} */

	.message-time-footer {
		margin-top: 6px;
		font-size: 12px;
		color: #97a8be;
	}

	.user-time {
		text-align: right;
		margin-right: 62px;
	}

	.admin-time {
		margin-left: 62px;
	}

	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #97a8be;
		padding: 60px 0;
		font-size: 14px;
		flex: 1;
	}

	.empty-icon {
		margin-bottom: 16px;
		color: #c0ccda;
	}

	/* 输入区域样式 */
	.input-area {
		padding: 20px;
		border-top: 1px solid #e8e8e8;
		background-color: white;
		display: flex;
		align-items: flex-end;
		gap: 12px;
	}

	.input-container {
		flex: 1;
		position: relative;
		border: 1px solid #e0e0e0;
		border-radius: 12px;
		overflow: hidden;
		min-height: 200px;
		max-height: 300px;
		resize: vertical;
		background-color: #fff;
		transition: all 0.2s;
	}

	.input-container:focus-within {
		border-color: #1890ff;
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
	}

	.input-container.disabled {
		background-color: #f5f5f5;
		cursor: not-allowed;
		opacity: 0.6;
	}

	.message-input {
		width: 100%;
		min-height: 130px;
		padding: 16px;
		border: none;
		outline: none;
		font-size: 14px;
		line-height: 1.5;
		overflow-y: auto;
		background: transparent;
		resize: none;
		font-family: inherit;
	}

	.message-input:empty:before {
		content: attr(placeholder);
		color: #bfbfbf;
	}

	/* 输入框中图片的样式 */
	.message-input img {
		max-width: 200px;
		max-height: 150px;
		border-radius: 4px;
		margin: 2px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		vertical-align: middle;
	}

	.input-actions {
		display: flex;
		padding: 0 12px;
		/* border-top: 1px solid #f0f0f0; */
		background-color: #fff;
	}

	.action-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		/* width: 52px; */
		height: 36px;
		border: none;
		background: transparent;
		border-radius: 8px;
		color: #5e6d82;
		cursor: pointer;
		transition: all 0.2s;
		margin-right: 8px;
	}

	.action-btn:hover {
		background-color: #e6f7ff;
		color: #1890ff;
	}



	.send-button {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		width: 100px;
		height: 48px;
		background: linear-gradient(135deg, #1890ff, #096dd9);
		color: white;
		border: none;
		border-radius: 10px;
		cursor: pointer;
		font-size: 14px;
		font-weight: 500;
		transition: all 0.2s;
		flex-shrink: 0;
		box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
	}

	.send-button:hover:not(:disabled) {
		background: linear-gradient(135deg, #096dd9, #0050b3);
		box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
		transform: translateY(-1px);
	}

	.send-button:active:not(:disabled) {
		transform: translateY(0);
	}

	.send-button:disabled {
		background: #f5f5f5;
		color: #bfbfbf;
		cursor: not-allowed;
		box-shadow: none;
	}

	/* 滚动条样式 */
	.session-list::-webkit-scrollbar,
	.message-list::-webkit-scrollbar {
		width: 6px;
	}

	.session-list::-webkit-scrollbar-track,
	.message-list::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	.session-list::-webkit-scrollbar-thumb,
	.message-list::-webkit-scrollbar-thumb {
		background: #9b9b9b;
		border-radius: 3px;
	}

	.session-list::-webkit-scrollbar-thumb:hover,
	.message-list::-webkit-scrollbar-thumb:hover {
		background: #929292;
		cursor: pointer;
	}

	.danger-box {
		max-width: 270px;
		min-width: 270px;
		overflow: hidden;
		cursor: pointer;
		display: flex;
		flex-direction: row;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.chat-container {
			flex-direction: column;
			height: 80vh;
		}

		.session-list {
			width: 100%;
			max-height: 200px;
		}

		.chat-header {
			padding: 12px 16px;
		}

		.input-area {
			padding: 16px;
		}

		.send-button {
			width: 80px;
		}
	}

	/* 输入区域样式优化 */
	.input-area {
		padding: 16px 20px;
		border-top: 1px solid #e8e8e8;
		background-color: white;
		display: flex;
		align-items: flex-end;
		gap: 12px;
	}

	.input-container {
		flex: 1;
		position: relative;
		border: 1px solid #e0e0e0;
		border-radius: 12px;
		overflow: hidden;
		min-height: 120px;
		max-height: 400px;
		background-color: #fff;
		transition: all 0.2s;
		display: flex;
		flex-direction: column;
	}

	.input-container:focus-within {
		border-color: #1890ff;
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
	}

	.input-container.disabled {
		background-color: #f5f5f5;
		cursor: not-allowed;
		opacity: 0.6;
	}

	.message-input {
		flex: 1;
		min-height: 80px;
		padding: 16px;
		border: none;
		outline: none;
		font-size: 14px;
		line-height: 1.5;
		overflow-y: auto;
		background: transparent;
		resize: none;
		font-family: inherit;
		width: 100%;
		box-sizing: border-box;
	}

	.message-input:empty:before {
		content: attr(placeholder);
		color: #bfbfbf;
	}

	.input-actions {
		display: flex;
		gap: 4px;
	}

	.action-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 6px 12px;
		border: none;
		background: transparent;
		border-radius: 6px;
		color: #5e6d82;
		cursor: pointer;
		transition: all 0.2s;
		font-size: 13px;
		font-weight: 500;
	}

	.action-btn:hover {
		background-color: #e6f7ff;
		color: #1890ff;
	}

	.resize-controls {
		display: flex;
		align-items: center;
	}

	.resize-handle {
		display: flex;
		align-items: center;
		justify-content: center;
		width: calc(100vw - 40vw);
		height: 10px;
		background-color: red;
		/* position: relative; */
		/* top: -106px; */
		border-radius: 6px;
		cursor: ns-resize;
		color: #97a8be;
		transition: all 0.2s;
	}

	.resize-handle.top {
		background-color: red;
	}

	.resize-handle.bottom {
		background-color: yellow;
	}

	.resize-handle:active {
		background-color: #d0e8ff;
	}

	/* 输入框中图片和视频的样式优化 */
	.message-input img {
		max-width: 200px;
		max-height: 150px;
		border-radius: 6px;
		margin: 4px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		vertical-align: middle;
		object-fit: contain;
	}

	.message-input div[style*="position: relative"] {
		margin: 4px;
		display: inline-block;
	}

	/* 发送按钮样式保持不变 */
	.send-button {
		/* 保持原有样式 */
	}

	/* 响应式设计优化 */
	@media (max-width: 768px) {
		.input-area {
			padding: 12px 16px;
			flex-direction: column;
			gap: 12px;
		}

		.input-container {
			width: 100%;
		}

		.send-button {
			width: 100%;
			height: 44px;
		}

		.input-controls {
			flex-direction: column;
			gap: 8px;
			align-items: flex-start;
		}

		.resize-controls {
			align-self: flex-end;
		}
	}






	.input-area {
		display: flex;
		gap: 15px;
		margin-bottom: 20px;
	}

	.input-container {
		flex: 1;
		position: relative;
		border: 1px solid #ddd;
		border-radius: 12px;
		background-color: white;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
		overflow: hidden;
		min-height: 120px;
		min-width: 200px;
		resize: none;
	}

	.message-input {
		width: 100%;
		height: 100%;
		padding: 15px;
		border: none;
		outline: none;
		font-size: 16px;
		line-height: 1.5;
		resize: none;
		overflow-y: auto;
		min-height: 100px;
	}

	.message-input:empty:before {
		content: attr(placeholder);
		color: #aaa;
	}

	.input-controls {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 15px;
		border-top: 1px solid #eee;
		background-color: #fff;
	}

	.input-actions {
		display: flex;
		gap: 10px;
	}

	.action-btn {
		display: flex;
		align-items: center;
		gap: 5px;
		padding: 6px 12px;
		background-color: #e9ecef;
		border: none;
		border-radius: 6px;
		cursor: pointer;
		font-size: 14px;
		transition: all 0.2s;
	}

	.action-btn:hover {
		background-color: #dee2e6;
	}

	.resize-controls {
		display: flex;
		gap: 5px;
	}

	.resize-handle {
		width: 20px;
		height: 20px;
		background-color: #f9f9f9;
		border-radius: 4px;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		color: #666;
	}

	.resize-handle:hover {
		background-color: #3498db;
		color: white;
	}

	.send-button {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 12px 24px;
		background: linear-gradient(135deg, #3498db, #2980b9);
		color: white;
		border: none;
		border-radius: 12px;
		cursor: pointer;
		font-size: 16px;
		font-weight: 600;
		transition: all 0.3s;
		box-shadow: 0 4px 10px rgba(52, 152, 219, 0.3);
	}

	.send-button:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 15px rgba(52, 152, 219, 0.4);
	}

	.send-button:active {
		transform: translateY(0);
	}

	.resize-handles {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}

	.resize-handle-item {
		position: absolute;
		/* background-color: rgba(52, 152, 219, 0.3); */
		pointer-events: auto;
		z-index: 10;
		transition: background-color 0.2s;
	}

	.resize-handle-item:hover {
		/* background-color: rgba(52, 152, 219, 0.7); */
	}

	.resize-top {
		top: 0;
		left: 0;
		width: 100%;
		height: 8px;
		cursor: n-resize;
	}

	.resize-right {
		top: 0;
		right: 0;
		width: 8px;
		height: 100%;
		cursor: e-resize;
	}

	.resize-bottom {
		bottom: 0;
		left: 0;
		width: 100%;
		height: 8px;
		cursor: s-resize;
	}

	.resize-left {
		top: 0;
		left: 0;
		width: 8px;
		height: 100%;
		cursor: w-resize;
	}

	.resize-corner {
		width: 12px;
		height: 12px;
		background-color: rgba(52, 152, 219, 0.5);
		z-index: 11;
	}

	.resize-top-left {
		top: 0;
		left: 0;
		cursor: nw-resize;
	}

	.resize-top-right {
		top: 0;
		right: 0;
		cursor: ne-resize;
	}

	.resize-bottom-left {
		bottom: 0;
		left: 0;
		cursor: sw-resize;
	}

	.resize-bottom-right {
		bottom: 0;
		right: 0;
		cursor: se-resize;
	}

	.demo-info {
		margin-top: 30px;
		padding: 20px;
		background-color: #f8f9fa;
		border-radius: 12px;
		border-left: 4px solid #3498db;
	}

	.demo-info h3 {
		margin-bottom: 10px;
		color: #2c3e50;
	}

	.demo-info ul {
		padding-left: 20px;
		line-height: 1.6;
	}

	.demo-info li {
		margin-bottom: 8px;
	}

	.code-block {
		background-color: #2c3e50;
		color: #ecf0f1;
		padding: 15px;
		border-radius: 8px;
		margin-top: 15px;
		font-family: 'Courier New', monospace;
		font-size: 14px;
		overflow-x: auto;
	}
</style>